import { RouterModule, Routes } from '@angular/router';
import { V2LayoutComponent } from './v2-layout.component';
import { RouteModules } from '../../enums/route-modules.enum';
import { LoginGuard } from '../../common/auth/login.guard';

// app route components
import { PmcListComponent } from './pmc/pmc-list.component';
import { PmcDashboardComponent } from './pmc/pmc-dashboard/pmc-dashboard.component';
import { OrganizationsListComponent } from './organizations/organizations-list.component';
import { OrganizationDetailsComponent } from './organizations/organization-details/organization-details.component';
import { OrganizationAddComponent } from './organizations/organization-add/organization-add.component';
import { RequestFormsListComponent } from './request-forms/request-forms-list.component';
import { RequestFormSubmissionsComponent } from './request-forms/request-form-submissions/request-form-submissions.component';
import { RequestFormSubmissionDetailsComponent } from './request-forms/request-form-submissions/request-form-submission-details/request-form-submission-details.component';
import { ViolationsListComponent } from './violations/violations-list.component';
import { ViolationDetailsComponent } from './violations/violation-details/violation-details.component';
import { TeamListComponent } from './memberships/team/team-list.component';
import { LaunchpadComponent } from './launchpad/launchpad.component';
import { TeamMemberDetailsComponent } from './memberships/team/team-member-details/team-member-details.component';
import { TeamMemberAddComponent } from './memberships/team/team-member-add/team-member-add.component';
import { PermissionsGuard } from '../../common/auth/permissions.guard';
import { PmcFeatureFlagsComponent } from './pmc/pmc-feature-flags/pmc-feature-flags.component';

const pmcLayoutRoutes: Routes = [
    {
        canActivate: [
            LoginGuard,
            PermissionsGuard,
        ],
        path: 'pmc',
        component: V2LayoutComponent,
        data: {module: RouteModules.SUPER_ADMIN},
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'list',
            },
            {
                path: 'list',
                component: PmcListComponent,
                data: {module: RouteModules.SUPER_ADMIN},
            },
        ],
    },
    {
        canActivate: [
            LoginGuard,
            PermissionsGuard,
        ],
        path: 'pmc/:pmcId',
        component: V2LayoutComponent,
        data: {
            feature: 'pmc-dashboard.enabled',
            module: RouteModules.PMC_USER,
        },
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'dashboard',
            },
            {
                path: 'launchpad',
                component: LaunchpadComponent,
                data: {module: RouteModules.DASHBOARD},
            },
            {
                path: 'dashboard',
                component: PmcDashboardComponent,
                data: {module: RouteModules.DASHBOARD},
            },
            {
                path: 'communities',
                component: OrganizationsListComponent,
                data: {module: RouteModules.COMMUNITIES},
            },
            {
                path: 'communities/:communityId/details',
                component: OrganizationDetailsComponent,
                data: {module: RouteModules.COMMUNITIES},
            },
            {
                path: 'communities/add',
                component: OrganizationAddComponent,
                data: {module: RouteModules.COMMUNITIES},
            },
            {
                path: 'team',
                component: TeamListComponent,
                data: {module: RouteModules.TEAM},
            },
            {
                path: 'team/:userId/details',
                component: TeamMemberDetailsComponent,
                data: {module: RouteModules.TEAM},
            },
            {
                path: 'team/add',
                component: TeamMemberAddComponent,
                data: {module: RouteModules.TEAM},
            },
            {
                path: 'requests',
                component: RequestFormsListComponent,
                data: {module: RouteModules.REQUEST_FORMS},
            },
            {
                path: 'requests/submissions',
                component: RequestFormSubmissionsComponent,
                data: {module: RouteModules.REQUEST_FORMS},
            },
            {
                path: 'requests/submissions/:submissionId/details',
                component: RequestFormSubmissionDetailsComponent,
                data: {module: RouteModules.REQUEST_FORMS},
            },
            {
                path: 'violations',
                component: ViolationsListComponent,
                data: {module: RouteModules.VIOLATION},
            },
            {
                path: 'violations/:violationId/details',
                component: ViolationDetailsComponent,
                data: {module: RouteModules.VIOLATION},
            },
            {
                path: 'feature-flags',
                component: PmcFeatureFlagsComponent,
                data: {module: RouteModules.SUPER_ADMIN},
            },
        ],
    },
];

export const v2LayoutRouting = RouterModule.forChild(pmcLayoutRoutes);
